:root {
  --primary-color: #ffffff;
  --bg-color: #000000;
  --glass-bg: rgba(255, 255, 255, 0.1);
  --glass-border: rgba(255, 255, 255, 0.2);
  --text-color: #ffffff;
  --text-secondary: rgba(255, 255, 255, 0.7);
  --text-muted: rgba(255, 255, 255, 0.5);
  --bg-hover: rgba(255, 255, 255, 0.1);
  --bg-hover-light: rgba(255, 255, 255, 0.05);
  --border-color: rgba(255, 255, 255, 0.1);
  --text-shadow: 0 2px 4px rgba(0,0,0,0.5);
  font-family: 'Inter', system-ui, Avenir, Helvetica, Arial, sans-serif;
  color-scheme: light dark;
}

.theme-light {
  --primary-color: #3b82f6;
  --bg-color: #f0f2f5;
  --glass-bg: rgba(255, 255, 255, 0.95);
  --glass-border: rgba(0, 0, 0, 0.05);
  --text-color: #333333;
  --text-secondary: rgba(0, 0, 0, 0.6);
  --text-muted: rgba(0, 0, 0, 0.4);
  --bg-hover: rgba(0, 0, 0, 0.05);
  --bg-hover-light: rgba(0, 0, 0, 0.03);
  --border-color: rgba(0, 0, 0, 0.1);
  --text-shadow: none;
  color-scheme: light;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  margin: 0;
  display: flex;
  place-items: center;
  min-width: 320px;
  min-height: 100vh;
  background-color: var(--bg-color);
  color: var(--text-color);
  overflow: hidden;
  font-family: 'Inter', sans-serif;
  user-select: none;
}

#root {
  width: 100%;
  height: 100%;
}
